module.exports = __webpack_public_path__ + "static/media/img-3-md.b3d00b85.jpg";